export {}

const LOGGER_URL = 'http://localhost:5050'

function send(level: string, args: unknown[]) {
  const serialized = args.map((a) => (typeof a === 'object' ? JSON.stringify(a) : String(a)))

  fetch(`${LOGGER_URL}/log`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ level, args: serialized }),
  }).catch(() => {})
}

declare global {
  interface Console {
    remote: (...args: unknown[]) => void
  }
}

console.remote = (...args: unknown[]) => {
  console.log('[remote]', ...args)
  send('remote', args)
}
